// extracted by mini-css-extract-plugin
export default {"body":"DeleteModelDialog_body__-IIut","preventMisalign":"DeleteModelDialog_preventMisalign__bP2yF","content":"DeleteModelDialog_content__7PqXL"};